import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectClassicEmbedRoute: InvariantJiraRoute = {
	name: 'issue-navigator-classic-embed',
	path: '/jira/software/c/projects/:projectKey/issues/embed',
};
